/** @format */

import React, { memo } from 'react'

import { Form } from './components'
import styles from './Sign.module.scss'

export const Sign = memo(() => (
  <div className={styles.wrapper}>
    <Form />
  </div>
))
